<template>
    <div class="wrapper">
        <div class="str-logo">
            <span class="logo-lg">
                <img :src="$root.serverBasePath + '/strata.png'" alt="Strata Connex"
                        height="49px">
            </span>
        </div>


        <div class="content-wrapper">
            <ProcessBar></ProcessBar>

            <div class="content-wrapper-form">
                <div class="register-form">
                        <h2 class="text-center font-weight-bold pb-3">
                            Hey {{ $store.state.authenticatedUserData.user.first_name }},
                        </h2>
                        <h3 class="text-center name-subhead my-3">Thanks for your application!</h3>
                        <p class="text-center px-md-5 px-sm-1">
                            Short description about Strata Connex’s value proposition or
                            irresistable offer.
                        </p>
                        <hr />

                        <div class="prfle-completion-box py-1 p-sm-0">
                            <h2 class="text-center prfle-complete">Profile Completion</h2>
                            <p class="text-center sub-prfle-txt mb-0" style="line-height:25px;">
                                Complete the below steps to start, create and manage jobs, search contractors, verify compliance and more.
                            </p>

                            <div class="progress-line mb-4 mt-3">
                                <b-progress
                                    :max="max"
                                    class="mb-3"
                                ></b-progress>
                                <p class="text-center progressbar-text">99% <span>Done</span></p>
                            </div>

                            <div v-if="review" class="under-review-box px-5 py-4">
                                <h5 class="circle">Your application is under review.</h5>
                                <p class="h-txt mb-0">Short description about what is<br> happening.</p>
                            </div>

                            <div v-else class="under-review-success-box px-5 py-4 mb-4">
                                        <h5 class="success-circle">Your application has been accepted</h5>
                                        <p class="h-txt">
                                            Your account is now active and ready to create a
                                            job
                                        </p>
                            </div>


                        </div>



                    <div style="display: table; margin: 0 auto;">
                        <b-button
                            variant="primary"
                            :to="{ name: 'manager-dashboard' }"
                            v-if="$store.state.authenticatedUserData.user.role_id == 2"
                            >View Dashboard</b-button
                        >
                        <b-button
                            variant="primary"
                            :to="{ name: 'contractor-dashboard' }"
                            v-else-if="$store.state.authenticatedUserData.user.role_id == 3"
                            >View Dashboard</b-button
                        >
                    </div>

                </div>
            </div>
        </div>
            <FooterComponent />

    </div>
</template>

<script>

import ProfileNav from "../pages/manager/includes/ProfileNav.vue";
import ProcessBar from "@frontend/pages/includes/ProcessBar.vue";
import FooterComponent from "../pages/includes/FooterComponent.vue";


export default {
    components:{
        ProfileNav,
        ProcessBar,
        FooterComponent
    },
    data() {
        return {
            max: 99,
            status: "", // under-review
            review: true,
            fullname: "",

        };
    },
    mounted() {
        this.getAccountStatus();
        this.changeRegistrationStatus();
    },
    methods: {
        getAccountStatus() {
             this.$root.$data.bsLoader = true;
            axios.post("api/getAccountStatus").then(response => {
                this.status = response.data.status;
                this.fullname = response.data.first_name + ' ' + response.data.last_name;
            }).catch((err) => {
                this.$root.$data.bsLoader = false;
            });
        },
        changeRegistrationStatus(){
            axios.post("api/changeRegistrationStatus").then(response => {
            });
        }
    }
};
</script>

<style scoped>

hr {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
}
</style>
